/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useContext, useState, useEffect, useMemo } from 'react';

import PropTypes from 'prop-types';
import { ViewModelServiceContext, ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { MLScriptComponent } from 'ml-components-common-react';
import { LocalDateUtil } from '@xengage/gw-portals-util-js';
import { MLLocalDateUtil, convertToSentenceCase } from 'ml-portals-util-js';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useTranslator } from '@jutro/locale';
import { MLBillingUtil } from 'ml-portals-util-react';
import '@xengage/gw-platform-translations';
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';

import MLBankAccountDetailsComponent from '../MLBankAccountDetailsComponent/MLBankAccountDetailsComponent';
import MLAgencySweepComponent from '../MLAgencySweepComponent/MLAgencySweepComponent';
import messages from './MLDownPaymentComponent.messages';
import metadata from './MLDownPaymentComponent.metadata.json5';
import styles from './MLDownPaymentComponent.module.scss';
import { Link } from '@jutro/router';

import { IntlContext } from '@jutro/legacy/locale';

// ML: MLPaymentDetailsDirectiveCtrl.js, ml-payment-details.html

function MLDownPaymentComponent(props) {
    const translator = useTranslator();
    const intl = useContext(IntlContext);

    const {
        id,
        onValidate,
        showValidationErrors,
        currentUser,
        paymentDetails,
        paymentInstruments,
        chosenQuoteData,
        gpaMode,
        qnbMode,
        submissionVM,
        onPaymentInstrumentChange,
        updateDownPaymentInstrument,
        refreshData: refreshParentData,
        isShowAgentPaymentChannel,
        addDownPaymentInstrument,
        isPayOnlineOrMailSelected,
        canShowCreditCard,
        hasPaymentInstrumentsForMethod,
        saveNewBankAccountPaymentInstrument,
        setHttpResponse,
        downPaymentDetailsUrl,
        canRemovePaymentInstrument,
        editPaymentInstrument,
        deletePaymentInstrument,
        setDownPaymentMethod,
        setErrorTimestamp,
        errorTimestamp,
        isAgencySweepOptionValid,
        usePaymentusAch,
        showDownPaymentInstrumentError
    } = props;

    const {
        MLRatingPaymentMethods,
        MLAccountPaymentMethods,
        MLUserTypes 
    } = appConfig;

    const { refreshData } = useDataRefresh();
    const { authUserData } = useAuthentication();

    const { onValidate: setComponentValidation, isComponentValid } = useValidation(id);
    useEffect(() => {
        if (onValidate) {
            onValidate(isComponentValid, id);
        }
    }, [id, onValidate, isComponentValid]);

    const viewModelService = useContext(ViewModelServiceContext);
    const newBankAccountDetails = () => {
        return viewModelService.create({ accountHolder: { value: {} } }, 'pc', 'metlife.edge.capabilities.policyjob.binding.dto.BankAccountDetailsDTOML');
    };
    const [bankAccountDetails] = useState(() => { return newBankAccountDetails(); });
    const getCreditCardIFrameHeight = () => {
        return '550px';
    };

    const agentInPersonChannelOption = viewModelService.productMetadata.get('pc').types.getTypelist('PaymentChannel_ML').getCode('AgentInPerson');
    const agentPhoneChannelOption = viewModelService.productMetadata.get('pc').types.getTypelist('PaymentChannel_ML').getCode('AgentPhone');

    const sessionUUID = _.get(submissionVM, "sessionUUID.value")

    const getSelectedPaymentPlan = () => {
        let paymentPlan;
        if (chosenQuoteData) {
            paymentPlan = _.find(chosenQuoteData.paymentPlans_ML, { billingId: paymentDetails.selectedPaymentPlan_ML.value });
        }
        return paymentPlan;
    };

    const getDownPaymentAmount = () => {
        const paymentPlan = getSelectedPaymentPlan();
        let downPaymentAmount = { amount: 0, currency: 'usd' };
        if (paymentPlan) {
            if (paymentPlan.downPayment && paymentPlan.downPayment.amount > 0) {
                downPaymentAmount = paymentPlan.downPaymentPlusFees_ML;
            } else {
                downPaymentAmount = paymentPlan.installmentPlusFees_ML;
            }
        }
        return downPaymentAmount;
    };

    const getFormatCurrency = (value) => {
        let formattedAmount = '';
        if (value) {
            const { amount, currency } = value;
            if (!_.isUndefined(amount) && currency) {
                formattedAmount = intl.formatNumber(
                    amount,
                    {
                        style: 'currency',
                        currency: currency
                    }
                );
            }
        }
        return formattedAmount;
    };

    const getLastFourSelectedAccount = (token) => {
        const selectedToken = token ?? paymentDetails.selectedPaymentInstrument_ML.value;
        return _.find(paymentInstruments, { token: selectedToken})?.last4Digits;
    };

    const KEY = `dp_method_selected${sessionUUID}`;

    const handleDownPaymentMethodValueChange = (value) => {
      if (qnbMode) {
        sessionStorage.setItem(KEY, value);
        setDownPaymentMethod(value);
      } else {
        setDownPaymentMethod(value);
      }
    };

    useEffect(() => {
      if (qnbMode && sessionUUID) {
        const saved = sessionStorage.getItem(KEY);

        if (saved) {
          setDownPaymentMethod(saved);
        }
      }
    }, [setDownPaymentMethod]);

    const {
        getDownPaymentMethodName
    } = MLBillingUtil();

    const getAvailableInstruments = () => {
        const values = [];
        if (canShowCreditCard()) {
            values.push(
                {
                    code: 'creditcard',
                    name: getDownPaymentMethodName(MLRatingPaymentMethods.CREDIT_CARD)
                }
            );
        }
        values.push(
            {
                code: 'ach',
                name: getDownPaymentMethodName(MLRatingPaymentMethods.BANK_ACCOUNT)
            }
        );
        if (isAgencySweepOptionValid()) {
            values.push(
                {
                    code: 'agencysweep',
                    name: translator(messages.AgencySweep)
                }
            );
        }
        return values;
    }
    const getPaymentNickname = (instrument) => {
        return instrument.nickname ? instrument.nickname : instrument.accountType_ML;
    };

    const setPaymentChannel = (value) => {
        if (value === 'inPerson') {
            _.set(paymentDetails, 'paymentChannel_ML.value', agentInPersonChannelOption);
        } else {
            _.set(paymentDetails, 'paymentChannel_ML.value', agentPhoneChannelOption);
        }
        refreshParentData();
    };

    const getPaymentChannelValue = () => {
        const channel = _.get(paymentDetails, 'paymentChannel_ML.value.code', '');
        if (channel === agentPhoneChannelOption.code) {
            return 'overPhone';
        }
        if (channel === agentInPersonChannelOption.code) {
            return 'inPerson';
        }
        return '';
    };

    const updateBankAccountDetails = () => {
        refreshData();
    };

    const DOWNPAYMENT_INSTRUMENT_TYPE = 'downpayment';
    const onLoadPaymentDetailsFrame = () => {
        setHttpResponse(DOWNPAYMENT_INSTRUMENT_TYPE);
    };

    const getNoPaymentInstrumentText = (method) => {
        return method && method.value === 'creditcard' ? translator(messages.CreditCardNotListed) : translator(messages.BankAccountNotListed)
    };

    const generateDataForRadioButton = (row) => {
        return {
            name: translator(messages.InstrumentOptionName, {
                nickname: getPaymentNickname(row),
                last4Digits: row.last4Digits
            }),
            code: row.token
        };
    };

    const generateActionColumn = (row, index) => {
        return (
            <div>
                <span className="edit-link">
                    <Link id={`edit${index}`} onClick={() => editPaymentInstrument(`${row.token}`, `${paymentDetails.downPaymentMethod_ML.value}`)}>{translator(messages.Edit)}</Link>
                </span>
                {canRemovePaymentInstrument(`${row.token}`) && (
                    <span> | </span>
                )}
                {canRemovePaymentInstrument(`${row.token}`) && (
                    <span className="edit-link">
                        <Link id={`remove${index}`} onClick={() => deletePaymentInstrument(`${row.token}`, `${paymentDetails.downPaymentMethod_ML.value}`)}>{translator(messages.Remove)}</Link>
                    </span>
                )}
            </div>
        );
    };

    const sortedData = useMemo(() => {
        const filteredData = _.filter(paymentInstruments, (paymentInstrument) => {
            return paymentInstrument.paymentMethod === paymentDetails.downPaymentMethod_ML.value
                && (paymentInstrument.portalAvailable !== false || paymentInstrument.paymentMethod === MLAccountPaymentMethods.CREDIT_CARD);
        })

        return _.sortBy(filteredData, (pmi) => pmi.last4Digits)
    }, [MLAccountPaymentMethods.CREDIT_CARD, paymentDetails.downPaymentMethod_ML.value, paymentInstruments])

    const resolvers = {
        resolveComponentMap: {
            mlbankaccountdetailscomponent: MLBankAccountDetailsComponent,
            mlagencysweepcomponent: MLAgencySweepComponent
        },
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            addDownPaymentInstrument: addDownPaymentInstrument
        }
    };

    const overrides = {
        downpaymentIsRequired: {
            content: translator(messages.DownpaymentRequired, { amount: getFormatCurrency(getDownPaymentAmount()) })
        },
        showCheckMessageContainer: {
            visible: gpaMode && isPayOnlineOrMailSelected()
        },
        downPaymentMethodInstruments: {
            availableValues: getAvailableInstruments(),
            onValueChange: (value) => handleDownPaymentMethodValueChange(value),
            className: qnbMode ? "radioButtonQnB" : ""
        },
        instrumentTable: {
            data: sortedData,
            visible: hasPaymentInstrumentsForMethod(paymentDetails.downPaymentMethod_ML.value)
        },
        accountListRow: {
            visible: paymentDetails.downPaymentMethod_ML.value === MLAccountPaymentMethods.CREDIT_CARD || (usePaymentusAch && paymentDetails.downPaymentMethod_ML.value === MLAccountPaymentMethods.BANK_ACCOUNT) || hasPaymentInstrumentsForMethod(paymentDetails.downPaymentMethod_ML.value)
        },
        splNoPaymentInstruments: {
            visible: (paymentDetails.downPaymentMethod_ML.value === 'creditcard' && !hasPaymentInstrumentsForMethod('creditcard')) || (usePaymentusAch && paymentDetails.downPaymentMethod_ML.value === MLAccountPaymentMethods.BANK_ACCOUNT && !hasPaymentInstrumentsForMethod('ach')),
            content: getNoPaymentInstrumentText(paymentDetails.downPaymentMethod_ML)
        },
        accountColumn: {
            option: generateDataForRadioButton,
            value: paymentDetails.downPaymentInstrument_ML.value,
            onValueChange: (value) => {
                onPaymentInstrumentChange(value);
            },
            cellClassName: qnbMode ? "radioButtonQnB cell" : "cell" 
        },
        actionColumn: {
            cell: generateActionColumn
        },
        addDownPaymentButton: {
            visible: paymentDetails.downPaymentMethod_ML.value !== 'agencysweep',
            className: qnbMode ? "secondaryButton widthSmall" : "",
            content: qnbMode ? convertToSentenceCase(translator(messages.AddAccount)) : translator(messages.AddAccount)
        },
        bankAccountDetailsComponent: {
            onValidate: setComponentValidation,
            showValidationErrors: showValidationErrors,
            bankAccountDetails,
            instrumentType: 'downpayment',
            onModelChange: updateBankAccountDetails,
            onSave: saveNewBankAccountPaymentInstrument,
            setErrorTimestamp,
            errorTimestamp,
            visible: !usePaymentusAch && paymentDetails.downPaymentMethod_ML.value === MLAccountPaymentMethods.BANK_ACCOUNT && hasPaymentInstrumentsForMethod(paymentDetails.downPaymentMethod_ML.value) === false
        },
        downPaymentPaymentusIframe: {
            id: 'DownPaymentDetailsFrame',
            src: downPaymentDetailsUrl,
            height: getCreditCardIFrameHeight(),
            className: 'PaymentusPaymentDetailsFrame',
            onLoad: onLoadPaymentDetailsFrame,
            visible: false
        },
        paymentChannelContainer: {
            visible: isShowAgentPaymentChannel() && paymentDetails.downPaymentMethod_ML.value === MLAccountPaymentMethods.BANK_ACCOUNT
        },
        paymentChannel: {
            value: getPaymentChannelValue(),
            onValueChange: (val) => setPaymentChannel(val)
        },
        agencySweepContainer: {
            visible: paymentDetails.downPaymentMethod_ML.value === 'agencysweep'
        },
        agencySweepComponnet: {
            onValidate: setComponentValidation,
            showValidationErrors: showValidationErrors,
            onModelChange: refreshParentData,
            sweepInfo: _.get(currentUser, 'primaryProducerCode_ML.agencySweepInfo_ML'),
            paymentDetails
        },
        paymentInstrumentAlert: {
            visible: showDownPaymentInstrumentError,
            message: messages.preferredPaymentMethodErrorMessage
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            model={paymentDetails}
            onValidationChange={setComponentValidation}
            showErrors={showValidationErrors}
            onModelChange={refreshParentData}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

MLDownPaymentComponent.propTypes = {
    id: PropTypes.string.isRequired,
    onValidate: PropTypes.func.isRequired,
    showValidationErrors: PropTypes.bool.isRequired,
    currentUser: PropTypes.shape({}).isRequired,
    paymentDetails: PropTypes.shape({
        downPaymentInstrument_ML: PropTypes.shape({
            value: PropTypes.string
        }),
        selectedPaymentPlan_ML: PropTypes.shape({
            value: PropTypes.string
        }),
        downPaymentMethod_ML: PropTypes.shape({
            value: PropTypes.string
        })
    }).isRequired,
    chosenQuoteData: PropTypes.shape({
        paymentPlans_ML: PropTypes.arrayOf(PropTypes.shape({}))
    }).isRequired,
    gpaMode: PropTypes.bool.isRequired,
    onPaymentInstrumentChange: PropTypes.func.isRequired,
    refreshParentData: PropTypes.func.isRequired,
    isShowAgentPaymentChannel: PropTypes.func.isRequired,
    paymentInstruments: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    addDownPaymentInstrument: PropTypes.func.isRequired,
    isPayOnlineOrMailSelected: PropTypes.func.isRequired,
    canShowCreditCard: PropTypes.func.isRequired,
    hasPaymentInstrumentsForMethod: PropTypes.func.isRequired,
    saveNewBankAccountPaymentInstrument: PropTypes.func,
    setHttpResponse: PropTypes.func,
    downPaymentDetailsUrl: PropTypes.string,
    canRemovePaymentInstrument: PropTypes.func.isRequired,
    editPaymentInstrument: PropTypes.func.isRequired,
    deletePaymentInstrument: PropTypes.func.isRequired,
    setDownPaymentMethod: PropTypes.func.isRequired,
    isAgencySweepOptionValid: PropTypes.func.isRequired,
    usePaymentusAch: PropTypes.bool
};

MLDownPaymentComponent.defaultProps = {
    saveNewBankAccountPaymentInstrument: undefined,
    setHttpResponse: undefined,
    downPaymentDetailsUrl: undefined,
    refreshParentData: _.noop
};

export default MLDownPaymentComponent;
